// src/redux/actions/promptActions.js

import { postRequest, getRequest } from "../../Apis/apiWrapper";
import { AI_MARKETING } from "../../utils/constants/httpConstants";
import {
  PROMPT_REQUEST,
  PROMPT_SUCCESS,
  PROMPT_FAIL,
} from "../constants/promptConstants";

export const getPromptListData =
  (sentQuery, navigate) => async (dispatch, getState) => {
    try {
      dispatch({ type: PROMPT_REQUEST });

      // Fetch user list
      let userList = [];
      try {
        const userResponse = await getRequest(
          navigate,
          "https://webservicelive.reachiq.ai/auth/api/v2.0/user-list"
        );
        if (
          userResponse?.status === 200 &&
          Array.isArray(userResponse.data.data)
        ) {
          userList = userResponse.data.data;
        }
      } catch (userError) {
        console.error("Error fetching user list:", userError);
      }

      // ✅ Build base query
      const apiQuery = {
        page: sentQuery?.page || 1,
        limit: sentQuery?.limit || 25,
        search: sentQuery?.search || "",
        ...(sentQuery?.direction && { direction: sentQuery.direction }),
        ...(sentQuery?.parent && { parent: sentQuery.parent }),
      };

      // ✅ Add sort: default is created_at desc
      if (sentQuery?.sort) {
        if (typeof sentQuery.sort === "string") {
          apiQuery.sort = {
            id: sentQuery.sort,
            direction: sentQuery?.direction === "asc" ? "asc" : "desc",
          };
        } else if (typeof sentQuery.sort === "object" && sentQuery.sort.id) {
          apiQuery.sort = {
            id: sentQuery.sort.id,
            direction: sentQuery.sort.direction || "desc",
          };
        }
      } else {
        // Default case
        apiQuery.sort = {
          id: "created_at",
          direction: "desc",
        };
      }

      const response = await postRequest(
        navigate,
        AI_MARKETING.getAllPrompts,
        apiQuery
      );

      if (response?.status === 200) {
        const responseData = response?.data?.data;
        let promptData = responseData?.data || [];

        if (Array.isArray(promptData) && userList.length > 0) {
          promptData = promptData.map((prompt) => {
            const user = userList.find(
              (user) => user._id === prompt.created_by
            );
            const ownerName = user
              ? `${user.first_name || ""} ${user.last_name || ""}`.trim() ||
                "No Name"
              : "No Name";

            return {
              ...prompt,
              owner_name: ownerName,
            };
          });
        }

        dispatch({
          type: PROMPT_SUCCESS,
          payload: {
            data: { records: promptData },
            total_records: responseData?.total || 0,
            query: sentQuery,
            is_empty: promptData.length === 0,
          },
        });
      } else {
        throw new Error("Failed to fetch prompts");
      }
    } catch (err) {
      console.error("Error fetching prompt list data:", err);
      dispatch({
        type: PROMPT_FAIL,
        payload: err.message || "Failed to fetch prompts",
      });
    }
  };
